import * as React from "react";
import { ImageInput, ImageField } from "react-admin";

import TextInputRA from "../components/TextInputRA";
import HiddenInputRA from "../components/HiddenInputRA";
import GeneralSelect from "../components/GeneralSelect";
import LayoutContainer from "../components/LayoutContainer";
import LeftGridCreate from "../components/LeftGridCreate";
import RightGridCreate from "../components/RightGridCreate";
import { Box, Grid, Typography } from "@material-ui/core";
import PaymentChannelValidation from "../../../ValidationRules/PaymentChannelValidation";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";

const PaymentChannelCreate = (props) => (
  <LayoutContainer>
    <Grid container style={{ height: "100%" }}>
      <LeftGridCreate {...props} validate={PaymentChannelValidation}>
        <SfBreadcrumbs path="Management/Payment methods/Create Payment method" />
        <Box style={{ margin: 50 }}>
          <TextInputRA required label="Channel name" source="name" />
          <TextInputRA label="Description" source="desc" />
          <TextInputRA label="Account no." source="account_no" />
          <TextInputRA label="Account name." source="account_name" />
          <TextInputRA label="Action code" source="action_code" />
          <GeneralSelect
            require
            label="Payment method"
            source="payment_method_id"
            resource="payment-methods"
          />
          <GeneralSelect
            require
            label="Institute"
            source="institute_id"
            resource="institutes"
          />
          <Typography> Pictures</Typography>
          <ImageInput label="" accept="image/*" source="image">
            <ImageField source="src" title="title" />
          </ImageInput>
          <HiddenInputRA source="status" initialValue="Active" />
        </Box>
      </LeftGridCreate>
      <RightGridCreate />
    </Grid>
    {/* <Create {...props} title="Create Payment Channel">
      <SimpleForm>
        <TextInputRA label="Channel name" source="name" />
        <TextInputRA label="Description" source="desc" />
        <TextInputRA label="Account no." source="account_no" />
        <TextInputRA label="Account name." source="account_name" />
        <TextInputRA label="Action code" source="action_code" />
        <ReferenceArrayInput
          label="Payment method"
          source="payment_method_id"
          reference="payment-methods"
        >
          <SelectInputRA optionText="name" />
        </ReferenceArrayInput>
        <ReferenceArrayInput
          label="Institute"
          source="institute_id"
          reference="institutes"
        >
          <SelectInputRA optionText="name" />
        </ReferenceArrayInput>
        <ImageInput label="Pictures" accept="image/*" source="image">
          <ImageField source="src" title="title" />
        </ImageInput>
        <HiddenInputRA source="status" initialValue="Active" />
      </SimpleForm>
    </Create> */}
    <PermissionChecker code="Page.Merchant.Management.Payment_Method" write />
  </LayoutContainer>
);

export default PaymentChannelCreate;
